import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { LoginService } from 'app/login.service';
import { Utilisateur } from 'app/models/Utilisateur';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Component({
  selector: 'app-popup-login',
  templateUrl: './popup-login.component.html',
  styleUrls: ['./popup-login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatButtonModule,
    FuseAlertComponent,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
})
export class PopupLoginComponent implements OnInit {
  @ViewChild('signInNgForm') signInNgForm: NgForm;
  @ViewChild('signUpNgForm') signUpNgForm: NgForm;

  alert: { type: FuseAlertType; message: string } = {
    type: 'error',
    message: "Nom d'utilisateur/Mot de passe incorrect",
  };

  alert1: { type: FuseAlertType; message: string } = {
    type: 'error',
    message: "Nom d'utilisateur / Email existe déjà",
  };
  alert2: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: 'Inscription réussie',
  };
  signInForm: UntypedFormGroup;
  showAlert: boolean = false;
  signUpForm: UntypedFormGroup;
  showAlert1: boolean = false;
  showAlert2: boolean = false;
  signin: boolean = true;
  signup: boolean = false;
  user: Utilisateur = new Utilisateur();
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private loginService: LoginService,
    private _formBuilder: UntypedFormBuilder,
    private utilisateurService: UtilisateurService,
    public dialog: MatDialog,
    private cookieService: SsrCookieService,
  ) {}

  ngOnInit(): void {
    this.signInForm = this._formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required],
    });

    // Create the form
    this.signUpForm = this._formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password1: ['', Validators.required],
      agreements: ['', Validators.requiredTrue],
    });
  }

  login() {
    if (this.signInForm.invalid) {
      return;
    }

    // Disable the form
    this.signInForm.disable();

    // Hide the alert
    this.showAlert = false;

    this.loginService
      .login(
        this.signInForm.value.user.toLowerCase(),
        this.signInForm.value.password,
      )
      .subscribe({
        next: (res: any) => {
          this.cookieService.set('token', res.access_token);
          if (isPlatformBrowser(this.platformId)) {
            window.location.reload();
          }
        },
        error: (err) => {
          this.signInForm.enable();
          this.signInNgForm.resetForm();
          this.showAlert = true;
        },
      });
  }

  signUp() {
    this.showAlert1 = false;

    if (this.signUpForm.valid) {
      // Disable the form
      this.signUpForm.disable();
    }

    this.loginService
      .signup(
        this.signUpForm.value.username,
        this.signUpForm.value.password1,
        this.signUpForm.value.email,
      )
      .subscribe({
        next: (res: any) => {
          this.user.userName = this.signUpForm.value.username.toLowerCase();
          this.user.motPasse = this.signUpForm.value.password1;
          this.user.email = this.signUpForm.value.email;
          this.loginService
            .login(
              this.signUpForm.value.username.toLowerCase(),
              this.signUpForm.value.password1,
            )
            .subscribe({
              next: (res: any) => {
                this.cookieService.set('token', res.access_token);
                location.reload();
              },
              error: (err) => {
                this.signInForm.enable();
                this.signInNgForm.resetForm();
                this.showAlert = true;
              },
            });
          this.utilisateurService
            .enregistrer(this.user)
            .subscribe((data) => {});
          this.showAlert1 = false;
          this.signUpForm.enable();
          this.signUpNgForm.resetForm();
          this.showAlert2 = true;
        },
        error: (err) => {
          if (err.status == '409') {
            this.showAlert1 = true;
          }
        },
      });
  }
  enableSignUp() {
    this.signup = true;
    this.signin = false;
  }
  enableSignIn() {
    this.signup = false;
    this.signin = true;
  }
  fermer() {
    this.dialog.closeAll();
  }
}
